/** Resolve schedule columns for SOA tables that inherit from another table (e.g. T2 ← T1). */

function tableIdOf(table) {
  return String(table?.tableId ?? "").trim();
}

export function resolveInheritedSoaColumns(table, allTables) {
  const own = Array.isArray(table?.columns) ? table.columns : [];
  if (own.length > 0) return own;

  const parentId = String(table?.inheritsFromTableId ?? "").trim();
  if (!parentId || !Array.isArray(allTables)) return [];

  const parent = allTables.find((t) => tableIdOf(t) === parentId);
  const parentCols = Array.isArray(parent?.columns) ? parent.columns : [];
  if (!parentCols.length) return [];

  return parentCols.map((col) => (col && typeof col === "object" ? { ...col } : col));
}

export function resolveSoaTableForRender(table, allTables) {
  if (!table || typeof table !== "object") return table;
  const columns = resolveInheritedSoaColumns(table, allTables);
  if (columns.length === 0 && Array.isArray(table.columns) && table.columns.length === 0) {
    return table;
  }
  if (columns === table.columns) return table;
  return { ...table, columns };
}

export function resolveSoaTablesForRender(tables) {
  const list = Array.isArray(tables) ? tables : [];
  return list.map((table) => resolveSoaTableForRender(table, list));
}
